import { apiRequest } from "./httpClient";

export default async function Login(username, pass){
    return apiRequest("api/users/login", { body: { username, password: pass } });
}

export async function Register(email, pass, username){
    return apiRequest("api/users/register", { body: { username, mail: email, password: pass } });
}

export async function RequestPasswordReset(email){
    return apiRequest("api/users/forgotten-password", { body: { mail: email } });
}